import { Injectable } from "@angular/core";
import { Color, Fill, GraphComponent, IGraph, Insets, Rect, SvgExport } from "@yfiles/yfiles";

@Injectable()
export class LinqYFilesExportService {
	printHelperPath = '/print';
	exportHelperPath = '/image';
    margins = new Insets(5)

	constructor() {

	}

    public async exportGraphAsSVG(graph:IGraph, fileName:string) {
        const svg = await this.createSVGString(graph, null)

        const element = document.createElement('a');
        element.setAttribute('href', "data:text/json;charset=UTF-8," + encodeURIComponent(svg.svg));
        element.setAttribute('download', fileName + ".svg");
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click(); // simulate click
        document.body.removeChild(element);
    }
   
    public async exportJPG(graph:IGraph, fileName:string) {
        const svg = await this.createSVGString(graph, 'white')

        this.convertSvg(svg.svg, svg.width, svg.height, 'image/jpeg').then(pngData => {
            //this.pngUrl = pngData;
            this.downloadPng(pngData, fileName + '.jpg');
        });
    }

    public async exportPNG(graph:IGraph, fileName:string) {
        const svg = await this.createSVGString(graph, null)

        this.convertSvg(svg.svg, svg.width, svg.height, 'image/png').then(pngData => {
            //this.pngUrl = pngData;
            this.downloadPng(pngData, fileName + '.png');
        });
    }

    public async createPNG(graph:IGraph) {
        const svg = await this.createSVGString(graph, null)

        const png = await this.convertSvg(svg.svg, svg.width, svg.height, 'image/png')
        return {png, width:svg.width, height:svg.height}
    }

    public async createSVGString(graph:IGraph, background:string|null, exportRect?:Rect, scale?:number):Promise<any> {
        // Create a new graph component for exporting the original SVG content
        const exportComponent = new GraphComponent()
        // ... and assign it the same graph.
        exportComponent.graph = graph
        exportComponent.updateContentBounds()
    
        // Determine the bounds of the exported area
        const targetRect = exportRect || exportComponent.contentBounds
    
        exportComponent.zoomTo(targetRect)
    
        // Create the exporter class
        const exporter = new SvgExport(targetRect, scale||1)
        //exporter.margins = this.margins
        exporter.background = background

        if (window.btoa != null) {
            // Don't use base 64 encoding if btoa is not available and don't inline images as-well.
            // Otherwise canvg will throw an exception.
            exporter.encodeImagesBase64 = true
            exporter.inlineSvgImages = true
        }
    
        const svgElement = await exporter.exportSvgAsync(exportComponent)
        const serializer = new XMLSerializer();
        const width = (new Number(svgElement.getAttribute("width").replace('px', ''))).valueOf()
        const height = (new Number(svgElement.getAttribute("height").replace('px', ''))).valueOf()

        return {svg:serializer.serializeToString(svgElement), width, height}
    }

    private downloadPng(dataUrl: string, filename: string) {
        const link = document.createElement('a');
        link.href = dataUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }      
    
    private async convertSvg(svgString: string, width: number, height: number, type:string): Promise<string> {
        return new Promise((resolve, reject) => {
          const svgBlob = new Blob([svgString], { type: 'image/svg+xml' });
          const url = URL.createObjectURL(svgBlob);
          
          const img = new Image();
        
          img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;

            const ctx = canvas.getContext('2d');
      
            if (ctx) {
              ctx.clearRect(0, 0, width, height);
              ctx.drawImage(img, 0, 0, width, height);
              
              // Convert canvas to PNG Base64 string
              const pngDataUrl = canvas.toDataURL(type, 1.0);
              resolve(pngDataUrl);
            } else {
              reject('Canvas context is not supported');
            }
      
            URL.revokeObjectURL(url);
          };
          
          img.onerror = reject;
          img.src = url;
        });
    }
}

